import React from 'react'
import TopNav from '../../Components/Navbar/Navbar.jsx';
import './Msoc.css';
export default function Msoc() {
  return (
    <div className="msoc-container">
      <TopNav page={'msoc'} />
      <div className='msoc-title'>Manipal Summer Of Code</div>
      <div className="coming-soon">COMING SOON</div>
    
    </div>
  )
}
